let container;

const cartItems = window.cartItems || [];

console.log('assure-flow');

async function fetchCompletion() {
  try {
    console.log('assure-flow fetch');

    const cartContentLine = cartItems.length
      ? cartItems.map((product) => product.product_title).join(',')
      : 'nothing';

    const completion = await fetch(
      'https://cbgqs0f011.execute-api.us-east-1.amazonaws.com/assure-cart-message?products=' + encodeURIComponent(cartContentLine),
      { method: 'GET' }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      return response.json();
    });

    const getHeader = () => {
      if (!cartItems.length) {
        return '<p class="preHeader"></p><h2>Empty for now...</h2>';
      }

      return `<p class="preHeader">${cartItems.length > 1 ? 'NICE PICKS!' : 'NICE PICK!'}</p><h2>Here's Why You'll Love What's in Your Cart</h2>`;
    };

    container.innerHTML = `
      <div class="headerWrapper">
        <div>
          ${getHeader()}
        </div>
      </div>
      <div class="content">${completion.openAIResponse || ''}</div>
      <div class="footer">Impact made. Let's go.</div>
    `;

    container.classList.add('open');
  } catch (e) {
    console.log('Completion error:', e);

    if (container) {
      container.innerHTML = '';
      container.classList.remove('open');
    }
  }
}

const containerCheck = setInterval(() => {
  container = document.querySelector('#assure-flow');

  if (container) {
    fetchCompletion();
    clearInterval(containerCheck);
  }
}, 200);